var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"c-form__input",attrs:{"type":"text","name":"sQuantity","id":"sQuantity","value":"1"}})}
var staticRenderFns = []

export { render, staticRenderFns }